import React from 'react'
import { connect } from 'react-redux'
import InputElement from '../../utils/input'

const mapStateToProps = (state, ownProps) => {
    const answer = state.answers?.find(a => a.groupQuestionId === ownProps.groupQuestionId && a.installationId === ownProps.installation.id)
    let answerValue = null
    if (answer) {
        answerValue = state.answerValues?.find(av => av.answerId === answer.id)
    }
    return {
        answer,
        answerValue
    }
}

const TextQuestion = ({ question, answer, answerValue, installation, type }) => {
    const renderNotes = () => {
        if (answerValue?._computed.statusValue === 'REJECTED') {
            return (
                <div className="rejected-notes">
                    <span className="error-label"> Error</span>
                    <p className="notes">
                        {answerValue.notes}
                    </p>
                </div>
            )
        }
        return null
    }

    let inputId = `answer_${answer?.id}`
    if (answerValue) {
        inputId = inputId + '_' + answerValue.id
    }

    const valueCalc = answerValue?.textValue || question?.defaultValue

    return (
        <>
            <InputElement
                type={type}
                id={inputId}
                default={valueCalc}
                label={question?.label}
                infoIcon={question?.instructions ? 'circle-info' : null}
                instructions={question?.instructions}
                placeholder={question?.placeholder}
                extraClass={`with-status ${answer?._computed.statusValue.toLowerCase()}`}
                readOnly={installation?._computed.statusDisplay === 'Submitted' ? true : false} />
            {renderNotes()}
        </>
    )
}

export default connect(mapStateToProps)(TextQuestion)
